import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchSchoolList } from './ducks/schoolList';
import SchoolList from './SchoolList';

const SchoolListPage = ()=>{
    const dispatch = useDispatch();
    const [searchKeyword, setSearchKeyword] = useState("");
    
    
    function onSubmit(event) {
        event.preventDefault();
        dispatch(fetchSchoolList(searchKeyword, 0));
    }

    function onSearchEnter(event) {
        if (event.key === 'Enter') {
            onSubmit(event);
        }
    }//end enter
    
    return (
        <div id="wrap">
            <div className="intro">
                <div className="logo"><img src="/repository/logo_home.png" alt="독서 길라잡이 로고" /></div>

                    <div className="search_area">
                        <form  onSubmit={onSubmit}>
                            <input type="text" name="searchKeyword" className="search_input" placeholder="학교명으로 찾아보세요." 
                                onKeyDown={onSearchEnter}
                                onChange={e=>setSearchKeyword(e.target.value)}
                                autoComplete="off"
                            />
                            <button type="submit" className="search_btn" onClick={onSubmit}></button>
                        </form>
                    </div>
                    <div className="search_result_area">
                        <SchoolList />
                    </div>

                <div className="intro_img"><img src={`${process.env.PUBLIC_URL}/images/main/intro_img.png`} alt="인트로페이지 이미지" /></div>
                <div className="gnedu_logo"><img src="/repository/owner_logo.png"  alt={`${window.serviceName} 로고`} /></div>
                <a href="http://author.iquiz.kr" target="_blank" rel="noreferrer" className="btn _xsm _border " style={{color:'#ffffff'}}>작가의 방</a>
            </div>
        </div>
    );
}//end class

export default SchoolListPage;
